import React, { useState, useEffect } from 'react'
import Breadcumb from '../../../components/Breadcumb/Breadcumb'
import { Container } from '@material-ui/core'
import { Categories, Alerts } from '../../../helpers';
import MUIDataTable from "mui-datatables";
import { Link } from 'react-router-dom'
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ViewCategoryModal from '../../../components/category/ViewCategoryModal';
import parse from 'html-react-parser';
const BreadcrumbData = [
  {
    id: 1,
    page_title: "Dashboard",
    page_path: "/",
    icon: "tachometer",
  },
  {
    id: 2,
    page_title: "Categories",
    page_path: "/",
    icon: "tachometer",
  }
]
const CategoriesList = () => {
  const [isLoading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(null);
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const getCategoriesData = async () => {
    let resp = await Categories.getCategories();
    if (resp && resp.status) {
      setCategories(resp.categories);
      setLoading(false)
    }
  }
  useEffect(() => {
    getCategoriesData();
  }, [])


  const destroyCategory = async (id) => {
    let resp = await Categories.deleteCategory(id)
    if (resp) {
      if (resp.status) {
        setCategories(categories.filter(el=>el.id !== id));
        Alerts.alertMessage(resp.message, '', 'success');
      }
    }
  }

  const viewData = (id) => {
    const category = categories.find(el => el.id === id);
    setCategory(category);
    setOpen(true);
  }


  const columns = [{
    name: "#SL",
    label: "#SL",
    options: {
      filter: false,
      sort: false
    }
  }, {
    name: "Name",
    label: "Name",
    options: {
      filter: false,
      sort: false
    }
  }, {
    name: "Description",
    label: "Description",
    options: {
      filter: false,
      sort: false
    }
  }
    , "Parent Category",
  {
    name: "Actions",
    label: "Actions",
    options: {
      filter: false,
      sort: false
    }
  },

  ]
  return (
    <>
      <Breadcumb items={BreadcrumbData} />
      <div className="page-wrapper pd30">
        <Container >
         

              <div className='page-inner-header'>
                <h3 className='m-0'>Categories</h3>
                <Link to={`/app/categories/create`} className="btn-primary action-btn">
                  Add New
                </Link>
              </div>

              {
                isLoading ? "Data Loading..." : <MUIDataTable
                  title="Categories"
                  data={categories.map((item, i) => {

                    return [
                      ++i,
                      item.name,
                      <div>{parse(item.description)}</div>,
                      <p>{`${item.parent ? `${item.parent?.name} >  ${item.name}` : '' }` }</p>,
                      <div className='actions'>
                        <button onClick={() => viewData(item.id)} className=" btn-success action-btn">
                          <VisibilityIcon fontSize="small" />
                        </button>
                        <Link to={`/app/categories/edit/${item.id}`} className=" btn-info action-btn">
                          <EditIcon fontSize="small" />
                        </Link>
                        <button onClick={() => { destroyCategory(item.id) }} className=" btn-danger action-btn">
                          <DeleteIcon fontSize="small" />
                        </button>
                      </div>

                    ]
                  })}
                  columns={columns}
                />
              }
              {
                category !== null && <ViewCategoryModal open={open} handleClose={handleClose} data={category} />
              }
           
        </Container>
      </div>

    </>
  )
}

export default CategoriesList